import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";
import { cn } from "@repo/ui/lib/utils";
import { useGender } from "@components/search/hooks/useGender";
import { useTranslations } from "next-intl";

export default function AlgoliaRefinementGender({ title }: { title: string }) {
  const { items, itemsFilterRule, toggleGroup } = useGender();
  const t = useTranslations("Products-list.filters");

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="item-1">
        <div className="py-[16px]">
          <AccordionTrigger className="max-md:text-base font-medium py-0 data-[state=open]:text-primary-magenta">
            {title}
          </AccordionTrigger>
          <AccordionContent className="mt-[20px] pb-0">
            <div className="flex flex-col gap-2 items-start">
              {items.filter(itemsFilterRule).map((group) => (
                <button
                  key={group.value}
                  type="button"
                  className={cn(
                    "flex items-center relative appearance-none  h-[24px] max-w-[24px] min-w-[24px] rounded-[5px] border-[2px] border-secondary-black border-opacity-50 bg-[#F8F6F7]",
                    {
                      "before:content-[''] before:flex before:justify-center before:items-center before:h-[12px] before:w-[12px]":
                        group.isRefined,
                    },
                    {
                      "before:rounded-full before:bg-primary-magenta before:absolute before:top-[4px] before:left-[4px]":
                        group.isRefined,
                    },
                  )}
                  onClick={() => toggleGroup(group.value)}
                >
                  <span className="ml-[30px] text-[14px]">
                    {t(group.label.toLowerCase())}
                  </span>
                </button>
              ))}
            </div>
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
